module.exports = " <div class=weui_cells_title> <slot></slot> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/.0.1.3@vux/src/components/group-title/index.vue
// module id = 224
// module chunks = 2